import React, { Component } from 'react';
import { Row, Col, Form, FormGroup, Label, Input, InputGroup, InputGroupAddon, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTwitter, faFacebookF, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import BenchmarkBuildingConsumption from './BenchmarkBuildingConsumption';
import classnames from 'classnames';
import './BenchmarkBuilding.css';
import {HorizontalBar} from 'react-chartjs-2';
import _ from 'lodash';
import buildingPrototypes from './data/buildingPrototypes.json'
 
const round = (number, places=2) => {
   const m = Math.pow(10, places);
   return Math.floor(number * m) / m;
}
	
const buildingListTemp = buildingPrototypes.map(({electricity, gas, vintage, image, ...keepAttrs}) => keepAttrs);
const buildingList = [...new Set(buildingListTemp.map(({type}) => type))];

class BenchmarkBuilding extends Component {

  constructor(props) {
    super(props);

		this.state = {
			gfa: '',
			gfaTextbox: '',
			activeGfaUnit: 'sqft',
      activeElectricityTab: 'electricityMonthly',
			activeGasTab: 'gasMonthly',
			energySourcesList: [],
			energyArray: [],
			electricityTotal: '',
			electricityMwh: '',
			electricityGhg: '',
			naturalGasTotal: '',
			naturalGasMwh: '',
			naturalGasGhg: '',
			districtHeatingTotal: '',
			districtHeatingMwh: '',
			districtHeatingGhg: '',
			districtCoolingTotal: '',
			districtCoolingMwh: '',
			districtCoolingGhg: '',
			totalMwh: '',
			totalGhg: '',
			buildingList: buildingList,
			buildingArray: buildingPrototypes,
			buildingImage: '',
			buildingDescription: '',
			buildingVintage: 'pre-1980',
			buildingType: '',
			prototypeElectricityEui: '',
			prototypeGasEui: '',
			prototypeElectricity: '',
			prototypeNaturalGas: '',
			prototypeElectricityGhg: '',
			prototypeNaturalGasGhg: '',
			totalPrototypeMwh: '',
			totalPrototypeGhg: '',
			barChartSelect: 'buildingMwh',
    };
  }

	handleCheck = (e) => {
		const sourceList = this.state.energySourcesList;
		const check = e.target.checked;
		const checkedSource = e.target.name;
		if(check){
			this.setState({
					energySourcesList: [...this.state.energySourcesList, checkedSource]
			})
		} else { 
			const index = sourceList.indexOf(checkedSource);
			if (index > -1) {
				sourceList.splice(index, 1);
				this.setState({
						energySourcesList: sourceList
				})
			} 
		}
	}
	
	toggleGfaUnit = (tab) => {
		const electricityTotal = this.state.electricityTotal;
		const naturalGasTotal = this.state.naturalGasTotal;
		const districtHeatingTotal = this.state.districtHeatingTotal;
		const districtCoolingTotal = this.state.districtCoolingTotal;
		const prototypeElectricityEui = this.state.prototypeElectricityEui;
		const prototypeGasEui = this.state.prototypeGasEui;
    if (this.state.activeGfaUnit !== tab) {
      this.setState({
        activeGfaUnit: tab
      });
				if (this.state.activeGfaUnit === 'sqft') {
					const gfa = this.state.gfa / 0.092903;
					this.setState({
						gfa: gfa
					})
					this.recalculateValues(gfa, electricityTotal, naturalGasTotal, districtHeatingTotal, districtCoolingTotal);
					this.recalculatePrototype(gfa, prototypeElectricityEui, prototypeGasEui);
				} else {
					const gfa = this.state.gfa * 0.092903;
					this.setState({
						gfa: gfa
				})
					this.recalculateValues(gfa, electricityTotal, naturalGasTotal, districtHeatingTotal,districtCoolingTotal);
					this.recalculatePrototype(gfa, prototypeElectricityEui, prototypeGasEui);				
			}
		}
	}
	
	handleBuildingSelect = (e) => {
		const gfa = this.state.gfa;
		const buildingArray = this.state.buildingArray;
		const buildingVintage = this.state.buildingVintage;
		const prototypeElectricityEui = buildingArray.filter(item => item.type === e.target.value && item.vintage === buildingVintage)[0].electricity;
		const prototypeGasEui = buildingArray.filter(item => item.type === e.target.value && item.vintage === buildingVintage)[0].gas;
		if(e.target.value === '') {
			this.setState({
				buildingType: '',
				buildingImage: '',
				buildingDescription: '',
				prototypeElectricityEui: '',
				prototypeGasEui: '',
			});
			this.recalculatePrototype(gfa, prototypeElectricityEui, prototypeGasEui);
			return;
		}
		this.setState({
			buildingType: e.target.value,
			buildingImage: buildingArray.filter(item => item.type === e.target.value)[0].image,
			buildingDescription: buildingArray.filter(item => item.type === e.target.value)[0].description,
			prototypeElectricityEui: prototypeElectricityEui,
			prototypeGasEui: prototypeGasEui,
    });
		this.recalculatePrototype(gfa, prototypeElectricityEui, prototypeGasEui);
  }
	
	handleVintageChange = (e) => {
		const gfa = this.state.gfa;
		const buildingArray = this.state.buildingArray;
		if(this.state.buildingType !== '') {
			const prototypeElectricityEui = buildingArray.filter(item => item.type === this.state.buildingType && item.vintage === e.target.value)[0].electricity; 
			const prototypeGasEui = buildingArray.filter(item => item.type === this.state.buildingType && item.vintage === e.target.value)[0].gas; 
			this.recalculatePrototype(gfa, prototypeElectricityEui, prototypeGasEui);
		}
		this.setState({
			buildingVintage: e.target.value
		});
	}
	
	handleEnergyChange = (array) => {
		
		const gfa = this.state.gfa;
		const electricityValues = _.filter(array, c => c.type === 'electricity' && c.value !== '');
		const electricityTotal = electricityValues.reduce(function (a,b) { return parseFloat(a) + parseFloat(b.value); }, 0);
		const naturalGasValues = _.filter(array, c => c.type === 'naturalGas' && c.value !== '');
		const naturalGasTotal = naturalGasValues.reduce(function (a,b) { return parseFloat(a) + parseFloat(b.value); }, 0) * 10.34444527;
		const districtHeatingValues = _.filter(array, c => c.type === 'districtHeating' && c.value !== '');
		const districtHeatingTotal = districtHeatingValues.reduce(function (a,b) { return parseFloat(a) + parseFloat(b.value); }, 0) * 0.351392213;
		const districtCoolingValues = _.filter(array, c => c.type === 'districtCooling' && c.value !== '');
		const districtCoolingTotal = districtCoolingValues.reduce(function (a,b) { return parseFloat(a) + parseFloat(b.value); }, 0) * 3.517;
		
		this.setState({
			energyArray: array,
			electricityTotal: electricityTotal,
			naturalGasTotal: naturalGasTotal,
			districtHeatingTotal: districtHeatingTotal,
			districtCoolingTotal: districtCoolingTotal,
		})
		
		this.recalculateValues(gfa, electricityTotal, naturalGasTotal, districtHeatingTotal, districtCoolingTotal);
	}
		
	handleKeyPress = (e) => {
		if (e.key === 'Enter') {
			e.preventDefault();
			e.target.blur();
		}
	}
	
	handleGfaChange = (e) => {
		const electricityTotal = this.state.electricityTotal;
		const naturalGasTotal = this.state.naturalGasTotal;
		const districtHeatingTotal = this.state.districtHeatingTotal;
		const districtCoolingTotal = this.state.districtCoolingTotal;
		const prototypeElectricityEui = this.state.prototypeElectricityEui;
		const prototypeGasEui = this.state.prototypeGasEui;
		
		this.setState({
			gfaTextbox: e.target.Value,				
		})	
		if(this.state.activeGfaUnit === 'sqft') {
			const gfa = parseFloat(e.target.value) * 0.092903;
			this.setState({
				gfa: gfa,
			})
			this.recalculateValues(gfa, electricityTotal, naturalGasTotal, districtHeatingTotal, districtCoolingTotal);
			this.recalculatePrototype(gfa, prototypeElectricityEui, prototypeGasEui);
		} else {
			const gfa = parseFloat(e.target.value);
			this.setState({
				gfa: parseFloat(e.target.value),
			})		
			this.recalculateValues(gfa, electricityTotal, naturalGasTotal, districtHeatingTotal, districtCoolingTotal);
			this.recalculatePrototype(gfa, prototypeElectricityEui, prototypeGasEui);
		};
			
	}
	
	recalculateValues = (newGfa, newET, newGT, newDH, newDC) => {
		const electricityMwh = round(newET / 1000, 1);
		const naturalGasMwh = round(newGT / 1000, 1);
		const districtHeatingMwh = round(newDH / 1000, 1);
		const districtCoolingMwh = round(newDC / 1000, 1);
		const electricityGhg = round(newET * 32 / 1000000, 1);
		const naturalGasGhg = round(newGT * 181.2180306 / 1000000, 1);
		const districtHeatingGhg = round(newDH * 210.0217286 / 1000000, 1);
		const districtCoolingGhg = round(newDC * 11.74296275 / 1000000, 1);
		
		this.setState({
			electricityMwh: electricityMwh,
			electricityGhg: electricityGhg,
			naturalGasMwh: naturalGasMwh,
			naturalGasGhg: naturalGasGhg,
			districtHeatingMwh: districtHeatingMwh,
			districtHeatingGhg: districtHeatingGhg,
			districtCoolingMwh: districtCoolingMwh,
			districtCoolingGhg: districtCoolingGhg,
			totalMwh: round(electricityMwh + naturalGasMwh + districtHeatingMwh + districtCoolingMwh, 1),
			totalGhg: round(electricityGhg + naturalGasGhg + districtHeatingGhg + districtCoolingGhg, 1),
		})	
	}
	
	recalculatePrototype = (newGfa, newPrototypeElectricityEui, newPrototypeNaturalGasEui) => {
		const prototypeElectricity = newGfa * newPrototypeElectricityEui / 1000;
		const prototypeNaturalGas = newGfa * newPrototypeNaturalGasEui / 1000;
		const prototypeElectricityGhg = round(newGfa * newPrototypeElectricityEui * 32 / 1000000, 1);
		const prototypeNaturalGasGhg = round(newGfa * newPrototypeNaturalGasEui * 181.2180306 / 1000000, 1);
		this.setState({
			prototypeElectricity: round(prototypeElectricity, 1),
			prototypeNaturalGas: round(prototypeNaturalGas, 1),
			totalPrototypeMwh: round(prototypeElectricity + prototypeNaturalGas, 1),
			prototypeElectricityGhg: round(prototypeElectricityGhg, 1),
			prototypeNaturalGasGhg: round(prototypeNaturalGasGhg, 1),
			totalPrototypeGhg: round(prototypeElectricityGhg + prototypeNaturalGasGhg, 1),
		})
	}
	
	handleBarChartButtonClick = (barChartSelect) => {
		this.setState({ barChartSelect });
  }	
	
  render() {
		
		const chartDataMwh = () => {
		const p = (v) => parseFloat(v) || 0;
		return {
			labels: ['Prototypical Building', 'Your Building'],
			datasets: [{
				label: 'Electricity',
				data: [p(this.state.prototypeElectricity), p(this.state.electricityMwh)],
				backgroundColor: '#fcb040',
				stack: 'stack',
			},
			{
				label: 'Natural Gas',
				data: [p(this.state.prototypeNaturalGas), p(this.state.naturalGasMwh)],
				backgroundColor: '#ff0000',
				stack: 'stack',
			},
			{
				label: 'District Heating',
				data: [0, p(this.state.districtHeatingMwh)],
				backgroundColor: '#bebdff',
				stack: 'stack',
			},
			{
				label: 'District Cooling',
				data: [0, p(this.state.districtCoolingMwh)],
				backgroundColor: '#5351a3',
				stack: 'stack',
			}]
		};
	}

	const chartDataGhg = () => {
		const p = (v) => parseFloat(v) || 0;
		return {
			labels: ['Prototypical Building', 'Your Building'],
			datasets: [{
				label: 'Electricity',
				data: [p(this.state.prototypeElectricityGhg), p(this.state.electricityGhg)],
				backgroundColor: '#fcb040',
				stack: 'stack',
			},
			{
				label: 'Natural Gas',
				data: [p(this.state.prototypeNaturalGasGhg), p(this.state.naturalGasGhg)],
				backgroundColor: '#ff0000',
				stack: 'stack',
			},
			{
				label: 'District Heating',
				data: [0, p(this.state.districtHeatingGhg)],
				backgroundColor: '#bebdff',
				stack: 'stack',
			},
			{
				label: 'District Cooling',
				data: [0, p(this.state.districtCoolingGhg)],
				backgroundColor: '#5351a3',
				stack: 'stack',
			}]
		};
	}	
	
	const chartOptionsDefault={
		legend: {
			display: false,
		},
		events: ['mousemove'], // this is needed, otherwise onHover is not fired
		scales: {
			xAxes: [{		
				gridLines: {
						display:false,
						drawBorder: false,
				},
				scaleLabel: {
					display: true,
				},
				ticks: {
					beginAtZero: true,
				},
				stacked: true,
			}],
			yAxes: [{		
				gridLines: {
					display:false,
				},
				stacked: true,
			}],
		},
		tooltips: {
			enabled: false,
		},
    responsive: false,
    animation: {
      duration: 0,
    },
    labels: {
      boxWidth: 10
    }
	};

	const chartOptionsMwh={
		title: {
			display: false,
		},
		scales: {
			xAxes: [{
				scaleLabel: {
					labelString: 'eMWh/year',
				}
			}],	
		}
	}
	
	const chartOptionsGhg={
		title: {
			display: false,
		},		
		scales: {
			xAxes: [{
				scaleLabel: {
					labelString: 'tCO₂e/year',
				}
			}],	
		}
	}	

	const barOptionsMwh = _.merge({}, chartOptionsDefault, chartOptionsMwh);
	const barOptionsGhg = _.merge({}, chartOptionsDefault, chartOptionsGhg);
	
    return (
		<div className='Benchmark-content'>
			<Row className='justify-content-center px-3'>
				<Col sm={12}>
					<h2 className='text-center'>Benchmark Your Building</h2>
				</Col>
				<Col md={12} lg={6} xl={5}>
					<div className='pr-4'>
						<h5>Step 1: Provide Your Building Characteristics</h5>
						<Form>
							<FormGroup row>
								<Col sm={7}>
									<Label for='benchmarkBuildingType'>Bulding Type</Label>
									<Input type='select' name='select' id='benchmarkBuildingType'
										onChange={this.handleBuildingSelect} defaultValue=''>
										<option value=''>Select a building prototype</option>
										{this.state.buildingList.map(item => <option value={item} key={item}>{item}</option>)}
									</Input>
							</Col>
							<Col sm={5}>
								<Label for='benchmarkGfa'>Gross Floor Area</Label>
								<InputGroup>
									<Input type='number' name='gfa' id='benchmarkGfa' placeholder='0' className='text-right' 
										value={this.state.gfaTextbox} 
										onChange={this.handleGfaChange}
										onKeyPress={this.handleKeyPress}
										/>
									<InputGroupAddon addonType='append'>
										<Button color='light'
											className={classnames({ active: this.state.activeGfaUnit === 'sqft' })}
												onClick={() => { this.toggleGfaUnit('sqft'); }}
												onChange={this.handleGfaChange}
											>
											ft²
										</Button>
									</InputGroupAddon>
									<InputGroupAddon addonType='append'>
										<Button color='light' 
											className={classnames({ active: this.state.activeGfaUnit === 'sqm' })}
												onClick={() => { this.toggleGfaUnit('sqm'); }}
												onChange={() => this.handleGfaChange()}
											>
											m²
										</Button>
									</InputGroupAddon>
								</InputGroup>
								</Col>
							</FormGroup>
							<FormGroup tag="fieldset">
								<legend className="col-form-label d-inline">Building Construction Period: &nbsp;</legend>
									<FormGroup check inline>
										<Label check>
											<Input type="radio" name="radio" 
												value='pre-1980'
												checked={this.state.buildingVintage === 'pre-1980'} 
												onChange={this.handleVintageChange}
											/>{' '}
											Pre-1980
										</Label>
									</FormGroup>
									<FormGroup check inline>
										<Label check>
											<Input type="radio" name="radio" 
												value='1980 to 2004'
												checked={this.state.buildingVintage === '1980 to 2004'} 
												onChange={this.handleVintageChange}
											/>{' '}
											1980 to 2004
										</Label>
									</FormGroup>
									<FormGroup check inline>
										<Label check>
											<Input type="radio" name="radio"
 												value='post-2004'
												checked={this.state.buildingVintage === 'post-2004'} 
												onChange={this.handleVintageChange}
											/>{' '}
											Post-2004
										</Label>
									</FormGroup>
							</FormGroup>
							<h5 className='step-2 pt-3'>Step 2: Enter Your Annual Energy Consumption</h5>
							<div>Choose your energy sources:</div>
							<FormGroup check inline>
							<Label check>
									<Input type='checkbox' name='electricity' onChange={this.handleCheck} /> Electricity
							</Label>
							</FormGroup>
							<FormGroup check inline>
							<Label check>
									<Input type='checkbox' name='naturalGas' onChange={this.handleCheck} />	Natural Gas
							</Label>
							</FormGroup>
							<FormGroup check inline>
							<Label check>
									<Input type='checkbox' name='districtHeating' onChange={this.handleCheck} /> District Heating
							</Label>
							</FormGroup>
							<FormGroup check inline>
							<Label check>
									<Input type='checkbox' name='districtCooling' onChange={this.handleCheck} /> Deep Lake Water Cooling
							</Label>
							</FormGroup>
							<br /><br />
							<FormGroup row>
							{this.state.energySourcesList.length !== 0 && <div className='px-3'>Enter your monthly or annual energy consumption:</div>}
								<BenchmarkBuildingConsumption 
									energySource={this.state.energySourcesList} 
									onEnergyChange={this.handleEnergyChange}
									energyArray={this.state.energyArray}
								/>
							</FormGroup>
							{this.state.energySourcesList.length !== 0 && <div><Button onClick={(e) => e.preventDefault()}>Update</Button>
							<Button className='ml-2'>Clear</Button></div>}
						</Form>
					</div>
				</Col>
				<Col sm={12} md={8} lg={4} xl={3}>
					<div className='m-4'>			
						<div>
							<img className='mx-auto' src={this.state.buildingImage} alt={this.state.buildingType} />
						</div>
						{this.state.gfa > 0 &&
							<div className='clearfix energy-charts'>
								<div className='chart-container'>
									<Row>
										<Col className='text-center'>
											<h6 className='large'>Energy Use</h6>
										</Col>
									</Row>
									<Row>
										<Col xs={8}></Col><Col xs={4} className='text-right'>eMWh/year</Col>
									</Row>
									<Row>
										<Col xs={8}>Prototypical Building:</Col><Col xs={4} className='text-right'>{this.state.totalPrototypeMwh.toFixed(0)}</Col>
									</Row>
									<Row>
										<Col xs={8}>Your Building:</Col><Col xs={4} className='text-right'>{this.state.totalMwh.toFixed(0)}</Col>
									</Row>
									<HorizontalBar data={chartDataMwh} options={barOptionsMwh} width={300} height={80} />
									<img className='legend' src='images/legend.png' alt='legend' />
								</div>
							</div>
						}
						{this.state.gfa > 0 &&
							<div className='clearfix energy-charts pt-3'>
								<div className='chart-container'>
									<Row>
										<Col className='text-center'>
											<h6 className='large'>GHG Emissions</h6>
										</Col>
									</Row>
									<Row>
										<Col xs={8}></Col><Col xs={4} className='text-right'> tCO₂e/year</Col>
									</Row>
									<Row>
										<Col xs={8}>Prototypical Building:</Col><Col xs={4} className='text-right'>{this.state.totalPrototypeGhg.toFixed(1)}</Col>
									</Row>
									<Row>
										<Col xs={8}>Your Building:</Col><Col xs={4} className='text-right'>{this.state.totalGhg.toFixed(1)}</Col>
									</Row>
									<HorizontalBar data={chartDataGhg} options={barOptionsGhg} width={300} height={80} />
									<img className='legend' src='images/legend.png' alt='legend' />
								</div>
							</div>
						}
					</div>
				</Col>
				</Row>
				<Row className='px-3'>
					<Col md={12} lg={{ size: 6, offset: 1}} xl={{ size: 5, offset: 2}}>
						<h5 className='step-3 pt-3'>Step 3: Find Energy Savings Incentives and Programs</h5>
						<Row>
						<Col sm={6}>
						Business
						<ul>
							<li><a href="http://www.torontohydro.com/sites/electricsystem/electricityconservation/businessconservation">Toronto Hydro</a></li>
							<li><a href="https://www.enbridgegas.com/Commercial-and-Industrial/Data-Sources/General-Information">Enbridge</a></li>
						</ul>
						</Col>		
						<Col sm={6}>
						Residential
						<ul>
							<li><a href="http://www.torontohydro.com/sites/electricsystem/electricityconservation/residentialconservation/Pages/default.aspx">Toronto Hydro</a></li>
							<li><a href="https://enbridgesmartsavings.com/home-energy-conservation">Enbridge</a></li>
						</ul>
						</Col>
						</Row>
					</Col>
				</Row>
			<Row>
				<Col sm={12} className='social text-center pb-5'>
					<a href="https://twitter.com/TO_2030District"><FontAwesomeIcon icon={faTwitter} size='lg' /></a>{'    '}
					<a href="https://www.linkedin.com/groups/8135789"><FontAwesomeIcon icon={faLinkedinIn} size='lg' /></a>{'    '}
					<a href="https://www.facebook.com/Toronto2030District/"><FontAwesomeIcon icon={faFacebookF} size='lg' /></a>
				</Col>
			</Row>
			<Row className='px-3'>
				<Col className='footer fixed-bottom bg-light py-2'>
					<p className='mb-0'><small>Disclaimer: The Benchmark Your Building tool is presented by the Canadian Urban Institute for educational and information purposes, which you may use at your own risk. Data entered into the tool are not recorded, saved, or transmitted in any way. <a href='/data-and-definitions#disclaimer'>Please read our full disclaimer.</a></small></p>
				</Col>
			</Row>
		</div>
		);
	}
}

export default BenchmarkBuilding;


// WEBPACK FOOTER //
// ./src/BenchmarkBuilding.js


// WEBPACK FOOTER //
// ./src/BenchmarkBuilding.js